<div class="card">
    <div class="card-header">
        <div class="card-title mb-0">Withdraw</div>
    </div>
    <div class="card-body">
        <div class="mb-3">
            <label for="name" class="form-label">Amount to Withdraw</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.withdraw" (input)="withdrawValueChange()" />
        </div>
        <hr/>
        <div class="mb-3">
            <div class="form-check">
                <input id="withdraw_only" class="form-check-input" type="checkbox" value="1" [(ngModel)]="data.withdraw_only"/>
                <label for="withdraw_only" class="form-check-label">Withdraw Point Only.</label>
            </div>
        </div>

        <div class="mb-3" *ngIf="!data.withdraw_only">
            <label for="name" class="form-label">Tips</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.withdraw_tips" />
        </div>

        <div class="mb-3" *ngIf="!data.withdraw_only">
            <label for="name" class="form-label">Point +/-</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.withdraw_point" [readonly]="setting.credit_calculation_method == 'auto'"/>
        </div>
        
        <div class="mb-3" *ngIf="!data.withdraw_only && (setting.hide_actual_pay_to_customer == 'false' || !setting.hide_actual_pay_to_customer)">
            <label for="name" class="form-label">Actual Pay to Customer Bank</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.actual_pay_to_bank" />
        </div>

        <div class="mb-3" *ngIf="!data.withdraw_only">
            <label for="name" class="form-label">Payout From</label>
            <ng-select
                #select
                class="modal-appended-select"
                bindLabel="title" 
                bindValue="id" 
                [items]="banks"
                [clearable]="true"
                [placeholder]="'Select Bank'"
                appendTo="body"
                dropdownPosition="auto"
                [(ngModel)]="data.withdraw_from_account" >
                <ng-template ng-label-tmp let-item="item">
                    <div>{{item.title}} ({{item.balance}})</div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    <div>{{item.title}} ({{item.balance}})</div>
                </ng-template>
            </ng-select>
        </div>
        <div class="mb-3" *ngIf="!data.withdraw_only">
            <div class="d-flex flex-row justify-content-between align-items-start">
                <label for="name" class="form-label">Payout To Account</label>
                <button class="btn btn-sm" (click)="copyAccount()" *ngIf="data.withdraw_to_account">COPY</button>
            </div>
            <ng-select
                    #payout
                    class="modal-appended-select"
                    bindLabel="bank" 
                    bindValue="id" 
                    [items]="player_banks"
                    [clearable]="true"
                    [placeholder]="'Select Account For Payout'"
                    appendTo="body"
                    dropdownPosition="auto"
                    [(ngModel)]="data.withdraw_to_account" >
                    <ng-template ng-label-tmp let-item="item">
                        <div>{{data.withdraw_to_account != "new" ? (item.bank + ' - ' + item.account) : "NEW"}}</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div>{{item.bank}} - {{item.account}}</div>
                    </ng-template>
                    <ng-template ng-footer-tmp>
                        <span (click)="createNewAccount()">Create New </span>
                    </ng-template>
                </ng-select>
            <div class="input-group mt-3" *ngIf="setting.enabled_finance_charge && setting.finance_charge_rate">
                <div class="input-group-append flex-fill">
                    <div class="input-group-text">
                        <label class="me-2" for="finance_charge">Finance Charge</label>
                        <select [(ngModel)]="data.finance_charge" #fc="ngModel" id="finance_charge" name="finance_charge" (change)="fcRateChange()" required>
                            <option [value]="true">YES</option>
                            <option [value]="false">No</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="mt-3" *ngIf="setting.enabled_finance_charge && setting.finance_charge_rate && data.withdraw && data.finance_charge === 'true'">
                Final Bank Transaction:<br/>{{data.actual_pay_to_bank ?? 0}} + {{setting.finance_charge_rate}} = <span class="text-danger fw-bolder">{{(data.actual_pay_to_bank ?? 0) + setting.finance_charge_rate}}</span>
            </div>
        </div>
        <ng-container *ngIf="data.withdraw_to_account == 'new'">
            <div class="mb-3">
                <label for="name" class="form-label">Bank Name</label>
                <input type="text" class="form-control" [(ngModel)]="data.withdraw_bank" />
            </div>
            <div class="mb-3">
                <label for="name" class="form-label">Account Number</label>
                <input type="text" class="form-control" [(ngModel)]="data.withdraw_account_no" />
            </div>
        </ng-container>
        <button class="btn btn-success w-100 btn-sm" (click)="withdraw()" type="submit" [disabled]="is_loading_function">Withdraw</button>
        <button class="btn btn-danger w-100 btn-sm mt-3" (click)="close()" type="button" [disabled]="is_loading_function">Close</button>

    </div>
</div>
